<template>
  <div>
    <el-tabs tab-position="left">
      <el-tab-pane label="团队排行">
        <el-table
          class="rank_list"
          :data="teamRankingList"
          height="calc(100vh - 60px - 59px - 60px - 60px)"
        >
          <el-table-column type="index" label="排名" width="100" align="center">
            <template slot-scope="scope">
              <img
                src="@/assets/images/icons/icon_first.png"
                alt
                v-if="scope.$index + 1 == 1"
              />
              <img
                src="@/assets/images/icons/icon_second.png"
                alt
                v-if="scope.$index + 1 == 2"
              />
              <img
                src="@/assets/images/icons/icon_third.png"
                alt
                v-if="scope.$index + 1 == 3"
              />
              <span v-if="scope.$index + 1 > 3">{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="teamName" label="团队名称"> </el-table-column>
          <el-table-column
            prop="captainName"
            label="队长"
            width="150"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="score" label="得分" width="150" align="center">
            <template slot-scope="scope">
              {{ scope.row.score ? Number(scope.row.score.toFixed(2)) : 0 }}
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="个人排行">
        <el-radio-group v-model="postId" size="medium">
          <el-radio-button
            :label="item.postId"
            v-for="item in postList"
            :key="item.postId"
            >{{ item.name }}</el-radio-button
          >
        </el-radio-group>
        <el-table
          class="rank_list mt"
          :data="memberPostRankingList"
          height="calc(100vh - 60px - 59px - 60px - 110px)"
        >
          <el-table-column type="index" label="排名" width="100" align="center">
            <template slot-scope="scope">
              <img
                src="@/assets/images/icons/icon_first.png"
                alt
                v-if="scope.$index + 1 == 1"
              />
              <img
                src="@/assets/images/icons/icon_second.png"
                alt
                v-if="scope.$index + 1 == 2"
              />
              <img
                src="@/assets/images/icons/icon_third.png"
                alt
                v-if="scope.$index + 1 == 3"
              />
              <span v-if="scope.$index + 1 > 3">{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="nickName"
            label="姓名"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.nickName || "无" }}
            </template>
          </el-table-column>
          <el-table-column prop="sno" label="学号" width="150" align="center">
            <template slot-scope="scope">
              {{ scope.row.sno || "-" }}
            </template>
          </el-table-column>
          <el-table-column prop="teamName" label="所属团队" align="center">
          </el-table-column>
          <el-table-column
            prop="totalScore"
            label="岗位总分"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row.totalScore
                  ? Number(scope.row.totalScore.toFixed(1))
                  : 0
              }}
            </template>
          </el-table-column>
          <el-table-column prop="score" label="得分" width="120" align="center">
            <template slot-scope="scope">
              {{ scope.row.score ? Number(scope.row.score.toFixed(1)) : 0 }}
            </template>
          </el-table-column>
          <el-table-column label="百分制得分" width="120" align="center">
            <template slot-scope="scope">
              {{
                scope.row.score
                  ? ((scope.row.score / scope.row.totalScore) * 100).toFixed(1)
                  : 0
              }}
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { teamRanking, memberRanking } from "@/api/teamGrade";
import { postList } from "@/api/post";
export default {
  data() {
    return {
      teamRankingList: [],
      memberRankingList: [],
      postList: [],
      postId: null,
    };
  },
  created() {
    this.getPostList();
  },
  computed: {
    memberPostRankingList() {
      return this.memberRankingList.filter((item) => {
        return item.postId == this.postId;
      });
    },
  },
  methods: {
    getRanking() {
      this.getTeamRanking();
      this.getMemberRanking();
    },
    getTeamRanking() {
      this.$loading.show();
      teamRanking({ classChapterId: this.$route.query.classChapterId }).then(
        (res) => {
          if (res.code == 0) {
            this.$loading.hide();
            this.teamRankingList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
    getMemberRanking() {
      this.$loading.show();
      memberRanking({ classChapterId: this.$route.query.classChapterId }).then(
        (res) => {
          if (res.code == 0) {
            this.$loading.hide();
            this.memberRankingList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
    getPostList() {
      postList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.postList = res.data;
          this.postId = res.data[0].postId;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .rank_list {
  &.mt {
    margin-top: 15px;
  }
  .is-leaf {
    color: #333;
    background-color: #f5f5f5;
  }
}
</style>